export const THOMAS_DEMO_PERSONA = Object.freeze({
  id: 'demo-thomas',
  email: 'thomas@talktoplus.demo',
  full_name: 'Thomas Nordstrom',
  role: 'board_director',
  tenant_id: 'demo-tenant',
  demo: true,
});

export function resolveDemoPersona(search = '', productMode = 'DEMO') {
  if (productMode !== 'DEMO') return null;
  const params = new URLSearchParams(search || '');
  return params.get('demo') === 'thomas' ? { ...THOMAS_DEMO_PERSONA } : null;
}

export function isDemoFallbackAllowed(search = '', productMode = 'PRODUCTION') {
  if (productMode === 'LIVE' || productMode === 'PRODUCTION') {
    return false;
  }
  const params = new URLSearchParams(search || '');
  return productMode === 'DEMO' && params.get('demo') === 'thomas';
}

export function resolveSafeFallbackData(error, productMode = 'PRODUCTION', search = '') {
  if (!isDemoFallbackAllowed(search, productMode)) {
    return null;
  }
  return DEMO_BOARDROOM_OVERVIEW;
}

export const DEMO_BOARDROOM_OVERVIEW = Object.freeze({
  risk_index: { value: 3.02, trend: 'stable', active: 2, total: 3 },
  risk_trend: [
    { date: 'Aug 26', value: 2.72 },
    { date: 'Aug 27', value: 2.88 },
    { date: 'Aug 28', value: 3.02 },
  ],
  heatmap: {
    risk_alignment: {
      public_ref: 'risk_alignment',
      label: 'Strategic Alignment',
      level: 'HIGH',
      count: 1,
      state: 'CONFIRMED',
    },
    risk_dependency: {
      public_ref: 'risk_dependency',
      label: 'Delivery Dependency',
      level: 'CRITICAL',
      count: 1,
      state: 'EMERGING',
    },
  },
  risk_distribution: [
    { name: 'CRITICAL', value: 1, percentage: 50 },
    { name: 'HIGH', value: 1, percentage: 50 },
  ],
  bottlenecks: [
    { id: 'risk_alignment', label: 'Strategic Alignment', percentage: 50 },
    { id: 'risk_dependency', label: 'Delivery Dependency', percentage: 50 },
  ],
  recent_validated_signals: [
    {
      id: 'demo-signal-alignment',
      content: 'Executive decision threshold requires final alignment before the next delivery gate.',
      risk_level: 'HIGH',
      risk_category: 'risk_alignment',
      state: 'CONFIRMED',
      related_risk: {
        public_ref: 'risk_alignment',
        label: 'Strategic Alignment',
        severity: 'HIGH',
        state: 'CONFIRMED',
      },
      validated_at: '2026-08-28T07:30:00Z',
      cascade_blocking_gates: ['board_alignment'],
    },
    {
      id: 'demo-signal-dependency',
      content: 'A critical external dependency needs an evidence-backed mitigation decision.',
      risk_level: 'CRITICAL',
      risk_category: 'risk_dependency',
      state: 'EMERGING',
      related_risk: {
        public_ref: 'risk_dependency',
        label: 'Delivery Dependency',
        severity: 'CRITICAL',
        state: 'EMERGING',
      },
      validated_at: '2026-08-28T06:45:00Z',
      cascade_blocking_gates: ['evidence_gate', 'red_team_gate'],
    },
  ],
  climate_signals: [],
  execution_readiness_summary: {
    state: 'READY_WITH_CONDITIONS',
    conditions: ['Evidence coverage', 'Human validation', 'Critical containment'],
    reasons: ['One critical dependency remains under active mitigation.'],
  },
  boardroom_projection: {
    readiness_state: 'READY_WITH_CONDITIONS',
    evidence_coverage: 86,
    evidence_sufficiency: { state: 'PARTIAL' },
    validated_count: 2,
    recent_total: 2,
    conditions_met: 2,
    conditions_total: 3,
    red_team_pending: 1,
    human_validation_state: 'VALIDATED',
    conditions: [
      { label: 'Evidence coverage', met: true },
      { label: 'Human validation', met: true },
      { label: 'Critical containment', met: false },
    ],
    readiness_dimensions: [
      { label: 'Epistemic Grounding (Evidence)', value: 86, state: 'SATISFIED' },
      { label: 'Decision Authority (Human)', value: 100, state: 'SATISFIED' },
      { label: 'Critical Path Containment', value: 50, state: 'WARNING' },
    ],
  },
});
